var mobileScreen = window.matchMedia("screen and (max-width:1199.98px)");

try {
	// Chrome & Firefox
	mobileScreen.addEventListener('change', (e) => {
		screenWidthChange(mobileScreen);
	});
} catch (e1) {
	try {
		// Safari
		mobileScreen.addListener((e) => {
			screenWidthChange(mobileScreen);
		});
	} catch (e2) {
		console.error(e2);
	}
}

screenWidthChange(mobileScreen);

function screenWidthChange(mobileScreen) {
	if ( mobileScreen.matches ) {

		import('./../components/mobile-menu-helper');
	}
}